module.exports = __webpack_public_path__ + "img/logo.39221cf9.png";